import { STATION_TYPE_CONSTANT } from 'station/constants/StationConstants'

export default class DtoInstallationAnalysisMeasureLight {
    constructor(obj) {
        this.date = obj[0]
        this.value = obj[1]
        this.instId = obj[2]
        this.type = STATION_TYPE_CONSTANT.installation
    }
}